var duration = 0,
	logosSections = document.querySelectorAll('section.logos');

logosSections.forEach(function(logosSection) {
	rows = logosSection ? logosSection.querySelectorAll('.row') : false;
	logosSection2 = logosSection.querySelector('div');
	console.log('logo 2 ',logosSection2);

	if(logosSection && !logosSection2.classList.contains('no-logo-scroll')) {
		var logosWaypoint = new Waypoint({
			element: logosSection,
			handler: function(direction) {
				setTimeout(function() {
					[].slice.call(rows).forEach(function(row) {
						duplicateLogos(row);
					});
				}, 1400);

				this.destroy();
			},
			offset: '100%'
		});
	}
});

function duplicateLogos(row) {
	var logos = row.querySelectorAll('li'),
		gap = parseInt(window.getComputedStyle(row).gap),
		rowWidth = 0;

	for(var i=0; i<logos.length; i++) {
		var clone = logos[i].cloneNode(true);

		row.append(clone);

		rowWidth+= (logos[i].offsetWidth + gap);
	}

	var computedDuration = (rowWidth / 1440) * 30000;

	if(computedDuration > duration)
		duration = Math.ceil(computedDuration);

	slideLogos(row, rowWidth);

	setInterval(function() {
		row.style = 'transform: translateX(0px);';

		setTimeout(function() {
			slideLogos(row, rowWidth);
		}, 10);
	}, duration);
}

function slideLogos(row, rowWidth) {
	row.style = 'transition: transform '+duration+'ms linear; transform: translateX(-'+rowWidth+'px);';
}